import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import type { MasonryContentItemModel } from './masonry-content-item.model';
import { MasonryCardComponent } from './masonry-card/masonry-card.component';

@Component({
  selector: 'wl-masonry',
  templateUrl: './masonry.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AutomationIdDirective, MasonryCardComponent],
})
export class MasonryComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() items?: MasonryContentItemModel[][];

  trackByMasonryColumn(_: number, model: MasonryContentItemModel[]) {
    return btoa(model.reduce((prev, item) => prev + item.itemUrl, ''));
  }

  trackByMasonryItem(index: number, model: MasonryContentItemModel) {
    return model.itemUrl || index;
  }
}
